module.exports = __webpack_public_path__ + "img/122.559f4f0d.jpg";